import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submit'];

  initialize() {
    this.checkRadios = this.checkRadios.bind(this);
  }

  get radios() {
    return Array.from(this.element.querySelectorAll('input[type="radio"]'));
  }

  connect() {
    this.radios.forEach((radio) => radio.addEventListener('change', this.checkRadios));
  }

  disconnect() {
    this.radios.forEach((radio) => radio.removeEventListener('change', this.checkRadios));
  }

  checkRadios() {
    const isOneRadioChecked = this.radios.some((radio) => radio.checked);
    this.submitTarget.disabled = !isOneRadioChecked;
  }
}
